import { ChatUnreadCountBadge } from '../ChatUnreadCountBadge/ChatUnreadCountBadge';
import { TotalUnreadMessageCountChipBadgeDocument, TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables } from './TotalUnreadMessageCountChipBadge.generated';
import useMe from '@ui/hooks/useMe';
import { ChannelMemberType } from '@mildang/graphql-artifact';
import { SystemStyleObject } from '@mildang/styled-system/types';
import { useQuery } from '@apollo/client';


export interface ComputedTotalUnreadCountBadgeProps {
  channelMemberType?: ChannelMemberType;
  badgePanda?: SystemStyleObject;
}

export const ComputedTotalUnreadCountBadge = (props: ComputedTotalUnreadCountBadgeProps) => {
  const { channelMemberType = 'STUDENT', badgePanda } = props;

  const { me } = useMe();
  const userId = me?.id ?? '';

  const { data } = useQuery<TotalUnreadMessageCountChipBadgeQuery, TotalUnreadMessageCountChipBadgeQueryVariables>(TotalUnreadMessageCountChipBadgeDocument, {
    skip: !userId,
    fetchPolicy: 'cache-and-network',
    variables: { userId: userId ?? '', channelMemberType },
  });

  return <ChatUnreadCountBadge unreadCount={data?.totalUnreadMessageCount ?? 0} panda={badgePanda} />;
};
